module.exports = __webpack_public_path__ + "img/07-Pic-flip-book.4848de32.png";